export default {
	environment: "production"
}
